import {SimplePromotion} from "./simple_promotion";
import {OrderDetail} from "./order_detail";

export class PromotionDetail {

   /**
    * 
    * @param {SimplePromotion} promotion 
    * @param {*} quantity 
    * @param {OrderDetail[]} order_details
    * @param {*} total 
    */
   constructor (promotion, quantity, order_details, total, discount, totalDiscounted){
      this.promotion_id = promotion.id
      this.promotion = promotion
      this.quantity = quantity
      this.order_details = order_details
      this.total = total
      this.discount = discount
      this.totalDiscounted = totalDiscounted
   }
}